import { DocumentTypes } from "./DocumentTypes"
import { Settings } from "./Settings"
import { StockControl } from "./StockControl"
import { StockDocumentEdit } from "./StockDocumentEdit"
import StockLocations from "./StockLocations"
export * from "./CreateStockLocationPage"

export const SettingsPage = Settings
export const StockLocationsPage = StockLocations
export const StockControlPage = StockControl
export const DocumentTypesPage = DocumentTypes
export const StockDocumentEditPage = StockDocumentEdit


// WEBPACK FOOTER //
// ./src/inventory/pages/index.ts